import { TaxType, TaxTypePayload } from '../../types';
import api from './client';

/** Shop-scoped tax types; each holds named rate components (Federal, State…). */
export const taxTypesService = {
  getTaxTypes: async (): Promise<TaxType[]> => {
    const response = await api.get<TaxType[]>('/tax-types');
    return response.data;
  },
  createTaxType: async (payload: TaxTypePayload): Promise<TaxType> => {
    const response = await api.post<TaxType>('/tax-types', payload);
    return response.data;
  },
  updateTaxType: async (
    id: string,
    payload: { name?: string; isActive?: boolean; components?: { name: string; rate: number }[] },
  ): Promise<TaxType> => {
    const response = await api.patch<TaxType>(`/tax-types/${id}`, payload);
    return response.data;
  },
  setDefaultTaxType: async (id: string): Promise<TaxType> => {
    const response = await api.post<TaxType>(`/tax-types/${id}/default`);
    return response.data;
  },
  deleteTaxType: async (id: string): Promise<void> => {
    await api.delete(`/tax-types/${id}`);
  },
};
